// extracted by mini-css-extract-plugin
export default {"container":"style_container__Lk2x+","section":"style_section__L0Rql","ssection":"style_ssection__-3Fma"};